import type { TwoFactorRequiredResponse } from '@axieinfinity/hub-services'
import { atom } from 'jotai'

type LoginDialogAtomState = { isVisible: boolean; redirect?: string }
export const loginDialogAtom = atom<LoginDialogAtomState>({ isVisible: false })

export const twoFactorTokenAtom = atom<null | TwoFactorRequiredResponse>(null)
